import * as Styled from './CompanyAvatar.styles';

type Props = {
  color: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

const CompanyAvatar = ({ color, Icon }: Props) => (
  <Styled.Avatar color={color}>
    <Icon />
  </Styled.Avatar>
);

export default CompanyAvatar;
